import { KEY } from "@/react/components/table/useTableMutations";

// Attributes is an object with the following structure
// attributeNameInMember: "attributeNameInParentObject"
export const appendPropertiesToMembers = (data, rows, attributes) => {
  const itemFromRows = [];
  /*
   * In order for members to assemble correctly, the whole row is necessary
   * based on row key
   */
  rows.forEach((value, key) =>
    itemFromRows.push(data.find((item) => item[KEY] === key))
  );

  /*
   * Add ringGroupSubscriptionId and customerId to each active (member.isActive) member
   * The above properties are given in the attributes parameter
   */
  return itemFromRows.map((item) => {
    const members = item.members
      ?.filter((member) => member.isActive)
      .map((member) => {
        // Removing isActive since it's only Frontend scoped
        const { isActive, ...fullMemberObject } = member;
        Object.keys(attributes).forEach((attribute) => {
          const itemAttribute = attributes[attribute];
          fullMemberObject[attribute] = item[itemAttribute];
        });
        return fullMemberObject;
      });
    return { ...item, members };
  });
};
